import React from 'react'

/**
 * Ikony z makiety „VoltValue dla domu” (kreska 24 × 24, jak heroicons, ale rysunki makiety: cel, projekt, rozeta
 * certyfikatu). Jedno miejsce dla strony `/dla-domu`, formularza zlecenia i listy wykonawców.
 */
const SCIEZKI = {
  ok: <path d="M5 12.5l4.2 4.2L19 7" />,
  strzalka: <path d="M5 12h14M13 6l6 6-6 6" />,
  dol: <path d="M6 9l6 6 6-6" />,
  x: <path d="M6 6l12 12M18 6 6 18" />,
  sklep: <><path d="M4 9.5 5.5 4h13L20 9.5" /><path d="M4 9.5a2.7 2.7 0 0 0 5.3 0 2.7 2.7 0 0 0 5.4 0 2.7 2.7 0 0 0 5.3 0" /><path d="M5.5 12.5V20h13v-7.5" /></>,
  cel: <><circle cx="12" cy="12" r="8.5" /><circle cx="12" cy="12" r="4.5" /><circle cx="12" cy="12" r="1.2" fill="currentColor" /></>,
  zestaw: <path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5zM3.5 7.5 12 12l8.5-4.5M12 12v9" />,
  projekt: <><path d="M4 18 7 6h13l-3 12z" /><path d="M5.5 12h13M11.3 6l-3 12M15.7 6l-3 12" /></>,
  kompas: <><circle cx="12" cy="12" r="9" /><path d="M15.5 8.5l-2 5-5 2 2-5z" /></>,
  dom: <><path d="M3 11l9-7 9 7" /><path d="M5 10v10h14V10" /><path d="M9 14h6M9 17h6" /></>,
  pinezka: <><path d="M12 21s-6-5.4-6-10a6 6 0 0 1 12 0c0 4.6-6 10-6 10z" /><circle cx="12" cy="11" r="2" /></>,
  tarcza: <><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" /><path d="M9 12l2 2 4-4" /></>,
  zegar: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  lista: <path d="M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2M4 12l1 1 2-2M4 18l1 1 2-2" />,
  dostawa: <path d="M3 6h11v10H3zM14 9h4l3 3v4h-7M6 18a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0M16 18a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0" />,
  klucz: <path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L4 17l3 3 5.3-5.3a4 4 0 0 0 5.4-5.4l-2.4 2.4-2.6-.4-.4-2.6z" />,
  dokument: <><path d="M7 3h7l5 5v13H7z" /><path d="M14 3v5h5M10 14l2 2 4-4" /></>,
  osoba: <><circle cx="12" cy="8" r="3.6" /><path d="M5 20c1.2-3.6 3.8-5.4 7-5.4s5.8 1.8 7 5.4" /></>,
  gwiazda: <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z" fill="currentColor" stroke="none" />,
  uwaga: <><circle cx="12" cy="12" r="9" /><path d="M12 8v5M12 16.5v.5" /></>,
}

const Ikona = ({ nazwa, rozmiar = 18, grubosc = 2.2, className }) => (
  <svg width={rozmiar} height={rozmiar} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={grubosc}
       strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className={className}>
    {SCIEZKI[nazwa]}
  </svg>
)

export default Ikona
